
export default function FloatingClouds({ cloudSrcs }) {
  const srcs = cloudSrcs || ['/cloud1.svg', '/cloud2.svg', '/cloud3.svg'];

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      <div className="absolute top-20 left-10 w-24 h-24 cloud-float opacity-20" style={{ animationDelay: '0s' }}>
        <img src={srcs[0]} alt="" className="w-full h-full object-contain" />
      </div>
      <div className="absolute top-40 right-20 w-32 h-32 cloud-float opacity-15" style={{ animationDelay: '5s' }}>
        <img src={srcs[1] || srcs[0]} alt="" className="w-full h-full object-contain" />
      </div>
      <div className="absolute bottom-40 left-1/4 w-28 h-28 cloud-float opacity-10" style={{ animationDelay: '10s' }}>
        <img src={srcs[2] || srcs[0]} alt="" className="w-full h-full object-contain" />
      </div>
      <div className="absolute top-1/3 right-1/4 w-20 h-20 cloud-float opacity-20" style={{ animationDelay: '15s' }}>
        <img src={srcs[0]} alt="" className="w-full h-full object-contain" />
      </div>
    </div>
  );
}
